export interface HousingAssociation {
  id: number
  name: string
  location: string
  yearEstablished: number
  overallScore: number
  residentExperienceScore: number
  financialPerformanceScore: number
  unitsManaged: number
  tenantSatisfaction: number
  imageUrl: string
  tags: string[]
}

export const housingAssociations: HousingAssociation[] = [
  {
    id: 1,
    name: 'Wheatley Group',
    location: 'Glasgow',
    yearEstablished: 2003,
    overallScore: 94,
    residentExperienceScore: 96,
    financialPerformanceScore: 91,
    unitsManaged: 38500,
    tenantSatisfaction: 92,
    imageUrl:
      'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&h=600&fit=crop',
    tags: ['Affordable Housing', 'Urban Regeneration', 'Care'],
  },
  {
    id: 2,
    name: 'Sanctuary Scotland',
    location: 'Edinburgh',
    yearEstablished: 2005,
    overallScore: 91,
    residentExperienceScore: 93,
    financialPerformanceScore: 88,
    unitsManaged: 7200,
    tenantSatisfaction: 90,
    imageUrl:
      'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&h=600&fit=crop',
    tags: ['Affordable Housing', 'Family Homes'],
  },
  {
    id: 3,
    name: 'Link Group',
    location: 'Edinburgh',
    yearEstablished: 1962,
    overallScore: 89,
    residentExperienceScore: 91,
    financialPerformanceScore: 86,
    unitsManaged: 8400,
    tenantSatisfaction: 89,
    imageUrl:
      'https://images.unsplash.com/photo-1582407947304-fd86f028f716?w=800&h=600&fit=crop',
    tags: ['Care', 'Sheltered Accommodation', 'Affordable Housing'],
  },
  {
    id: 4,
    name: 'Cairn Housing Association',
    location: 'Inverness',
    yearEstablished: 1975,
    overallScore: 87,
    residentExperienceScore: 89,
    financialPerformanceScore: 84,
    unitsManaged: 3100,
    tenantSatisfaction: 88,
    imageUrl:
      'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=800&h=600&fit=crop',
    tags: ['Rural Housing', 'Eco Housing'],
  },
  {
    id: 5,
    name: 'Albyn Housing Society',
    location: 'Highlands',
    yearEstablished: 1976,
    overallScore: 85,
    residentExperienceScore: 88,
    financialPerformanceScore: 81,
    unitsManaged: 2800,
    tenantSatisfaction: 87,
    imageUrl:
      'https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&h=600&fit=crop',
    tags: ['Rural Housing', 'Family Homes'],
  },
  {
    id: 6,
    name: 'Orkney Housing Association',
    location: 'Orkney',
    yearEstablished: 1990,
    overallScore: 84,
    residentExperienceScore: 87,
    financialPerformanceScore: 80,
    unitsManaged: 950,
    tenantSatisfaction: 86,
    imageUrl:
      'https://images.unsplash.com/photo-1568605114967-8130f3a36994?w=800&h=600&fit=crop',
    tags: ['Rural Housing', 'Eco Housing'],
  },
  {
    id: 7,
    name: 'Langstane Housing Association',
    location: 'Aberdeen',
    yearEstablished: 1975,
    overallScore: 82,
    residentExperienceScore: 85,
    financialPerformanceScore: 78,
    unitsManaged: 3600,
    tenantSatisfaction: 84,
    imageUrl:
      'https://images.unsplash.com/photo-1605146769289-440113cc3d00?w=800&h=600&fit=crop',
    tags: ['Affordable Housing', 'Family Homes'],
  },
  {
    id: 8,
    name: 'Fife Housing Group',
    location: 'Fife',
    yearEstablished: 2006,
    overallScore: 81,
    residentExperienceScore: 84,
    financialPerformanceScore: 77,
    unitsManaged: 6800,
    tenantSatisfaction: 83,
    imageUrl:
      'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&h=600&fit=crop',
    tags: ['Urban Regeneration', 'Affordable Housing'],
  },
  {
    id: 9,
    name: 'Weslo Housing Management',
    location: 'West Lothian',
    yearEstablished: 2002,
    overallScore: 79,
    residentExperienceScore: 82,
    financialPerformanceScore: 75,
    unitsManaged: 5200,
    tenantSatisfaction: 81,
    imageUrl:
      'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800&h=600&fit=crop',
    tags: ['Family Homes', 'Affordable Housing'],
  },
  {
    id: 10,
    name: 'Clyde Valley Housing Association',
    location: 'Lanarkshire',
    yearEstablished: 1977,
    overallScore: 78,
    residentExperienceScore: 81,
    financialPerformanceScore: 74,
    unitsManaged: 2900,
    tenantSatisfaction: 80,
    imageUrl:
      'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800&h=600&fit=crop',
    tags: ['Rural Housing', 'Family Homes'],
  },
  {
    id: 11,
    name: 'Dunbritton Housing Association',
    location: 'Dumbarton',
    yearEstablished: 1988,
    overallScore: 76,
    residentExperienceScore: 79,
    financialPerformanceScore: 72,
    unitsManaged: 1800,
    tenantSatisfaction: 78,
    imageUrl:
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop',
    tags: ['Affordable Housing', 'Urban Regeneration'],
  },
  {
    id: 12,
    name: 'Homes for Life Housing Partnership',
    location: 'Edinburgh',
    yearEstablished: 2002,
    overallScore: 75,
    residentExperienceScore: 78,
    financialPerformanceScore: 71,
    unitsManaged: 1200,
    tenantSatisfaction: 77,
    imageUrl:
      'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&h=600&fit=crop',
    tags: ['Eco Housing', 'Affordable Housing'],
  },
  {
    id: 13,
    name: 'Bield Housing Association',
    location: 'Edinburgh',
    yearEstablished: 1970,
    overallScore: 73,
    residentExperienceScore: 76,
    financialPerformanceScore: 69,
    unitsManaged: 3400,
    tenantSatisfaction: 75,
    imageUrl:
      'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800&h=600&fit=crop',
    tags: ['Sheltered Accommodation', 'Care'],
  },
  {
    id: 14,
    name: 'Loreburn Housing Association',
    location: 'Dumfries',
    yearEstablished: 2002,
    overallScore: 72,
    residentExperienceScore: 75,
    financialPerformanceScore: 68,
    unitsManaged: 2100,
    tenantSatisfaction: 74,
    imageUrl:
      'https://images.unsplash.com/photo-1600573472591-ee6b68d14c68?w=800&h=600&fit=crop',
    tags: ['Rural Housing', 'Family Homes'],
  },
  {
    id: 15,
    name: 'Eildon Housing Association',
    location: 'Scottish Borders',
    yearEstablished: 2002,
    overallScore: 70,
    residentExperienceScore: 73,
    financialPerformanceScore: 66,
    unitsManaged: 4200,
    tenantSatisfaction: 72,
    imageUrl:
      'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&h=600&fit=crop',
    tags: ['Rural Housing', 'Affordable Housing'],
  },
  {
    id: 16,
    name: 'Viewpoint Housing Association',
    location: 'Dundee',
    yearEstablished: 1988,
    overallScore: 69,
    residentExperienceScore: 72,
    financialPerformanceScore: 65,
    unitsManaged: 1600,
    tenantSatisfaction: 71,
    imageUrl:
      'https://images.unsplash.com/photo-1600607687644-c7171b42498b?w=800&h=600&fit=crop',
    tags: ['Urban Regeneration', 'Affordable Housing'],
  },
  {
    id: 17,
    name: 'Linthouse Housing Association',
    location: 'Glasgow',
    yearEstablished: 1975,
    overallScore: 67,
    residentExperienceScore: 70,
    financialPerformanceScore: 63,
    unitsManaged: 1100,
    tenantSatisfaction: 69,
    imageUrl:
      'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?w=800&h=600&fit=crop',
    tags: ['Urban Regeneration', 'Family Homes'],
  },
  {
    id: 18,
    name: 'Barony Housing Association',
    location: 'Ayrshire',
    yearEstablished: 1987,
    overallScore: 66,
    residentExperienceScore: 69,
    financialPerformanceScore: 62,
    unitsManaged: 1400,
    tenantSatisfaction: 68,
    imageUrl:
      'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&h=600&fit=crop',
    tags: ['Rural Housing', 'Care'],
  },
  {
    id: 19,
    name: 'Ardenglen Housing Association',
    location: 'Glasgow',
    yearEstablished: 1989,
    overallScore: 64,
    residentExperienceScore: 67,
    financialPerformanceScore: 60,
    unitsManaged: 850,
    tenantSatisfaction: 66,
    imageUrl:
      'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800&h=600&fit=crop',
    tags: ['Affordable Housing', 'Family Homes'],
  },
  {
    id: 20,
    name: 'Melville Housing Association',
    location: 'Edinburgh',
    yearEstablished: 1976,
    overallScore: 62,
    residentExperienceScore: 65,
    financialPerformanceScore: 58,
    unitsManaged: 920,
    tenantSatisfaction: 64,
    imageUrl:
      'https://images.unsplash.com/photo-1600585154084-4e5fe7c39198?w=800&h=600&fit=crop',
    tags: ['Sheltered Accommodation', 'Care'],
  },
]
